const prod = {
  API_URL: "https://api.koquetas.co/api",
  SESSION_SERVICE: "/Session",
  TOKEN_SERVICE: "/TokenAuth",
  USER_SERVICE: "/User",
  ORDER_SERVICE: "/Order",
  ROLE_SERVICE: "/Role",
  COLOR_SERVICE: "/Color",
  SIZE_SERVICE: "/Size",
  LINE_SERVICE: "/Line",
  SUBLINE_SERVICE: "/Subline",
  PRODUCT_SERVICE: "/Product",
  CLIENT_SERVICE: "/Client",
  PRICE_LIST_SERVICE: "/PriceList",
  STOCK_SERVICE: "/Stock",
  PACKAGE_SERVICE: "/Packages",
  DISPATCH_SERVICE: "/Dispatches",
  REPORT_SERVICE: "/Report",
  STOCK_TOTAL_SERVICE: "/StockTotal",
  CLIENTBRANCH_SERVICE: "/ClientBranch"
};

const dev = {
  API_URL: "http://localhost:5000/api",
  SESSION_SERVICE: "/Session",
  TOKEN_SERVICE: "/TokenAuth",
  USER_SERVICE: "/User",
  ORDER_SERVICE: "/Order",
  ROLE_SERVICE: "/Role",
  COLOR_SERVICE: "/Color",
  SIZE_SERVICE: "/Size",
  LINE_SERVICE: "/Line",
  SUBLINE_SERVICE: "/Subline",
  PRODUCT_SERVICE: "/Product",
  CLIENT_SERVICE: "/Client",
  PRICE_LIST_SERVICE: "/PriceList",
  STOCK_SERVICE: "/Stock",
  PACKAGE_SERVICE: "/Packages",
  DISPATCH_SERVICE: "/Dispatches",
  REPORT_SERVICE: "/Report",
  STOCK_TOTAL_SERVICE: "/StockTotal",
  CLIENTBRANCH_SERVICE: "/ClientBranch"
};

export const api = process.env.NODE_ENV === "development" ? dev : prod;
